import type { UsersFiltersFormProps } from './types'

export const initialFormValues: UsersFiltersFormProps = {
  code: '',
  user: '',
  role: 'Todos',
  profile: '0'
}
